sessionStorage.setItem('hmct', true);

$(".hmct-categories .item").click(function(){
  if($(this).hasClass("inactive")){
    $("#help-me-choose-tool").addClass("expanded");
    $(".hmct-categories .item").addClass("inactive");
    $(this).removeClass("inactive");
    var selectedCategory = $(this).data("hmctcategory");
    $(".hmct-categories .item .button-wrapper").slideUp();
    $(".hmct-content .hmct-content-item").slideUp().removeClass("active");
    $(".hmct-content .hmct-content-item-" + selectedCategory).slideDown().addClass("active");   
  }
});

function updateSliderNavigation(sliderName) {
  var sliderValue = $("#slider-"+sliderName).slider("option", "value"),
      levelItemSliderValue = $('.level-navigation-'+sliderName+' .level-item[data-level="'+sliderValue+'"]');
  $(".level-navigation-"+sliderName+" .level-item").removeClass("active");
  $(levelItemSliderValue).addClass("active");

}


var hideTooltip = function() {
  $(".ui-slider-handle").on("click", function(){
    $(".ui-slider .tooltip").hide();
  })
}


$(".level-navigation .level-item").on("click", function(){  
  var selectedLevelName = $(this).data("levelnavigationname");
  $(".level-navigation-"+selectedLevelName+" .level-item").removeClass("active");
  $(this).addClass("active");
  var SelectedLevel = $(this).data("level");
  $("#slider-"+selectedLevelName).slider('value', SelectedLevel);
  $(".hmct-product-"+selectedLevelName).removeClass("selected");
  $(".hmct-product-"+selectedLevelName+"-"+SelectedLevel).addClass("selected");
  $(".ui-slider .tooltip").hide();
})

$(".level-navigation a").on("click", function(e){
  e.preventDefault();
})


$(function() {
var slider = $( ".slider" ).slider({    
  min: 1,
  range: false,
  step: .0001,
  max: 3,
  value: 2,
  range: "min",
  animate:"slow",
  orientation: "horizontal",
  slide: function( event, ui ) {
    hideTooltip();
  },
  stop: function( event, ui ) {
    var currentSliderName = $(this).data("category");
    $("#slider-"+currentSliderName).slider('value',Math.round(ui.value));
    var selectedLevel = Math.round(ui.value);
    $(".hmct-product-"+currentSliderName).removeClass("selected");
    $(".hmct-product-"+currentSliderName+"-"+selectedLevel).addClass("selected");
    updateSliderNavigation(currentSliderName);   
    dataLayer.push({
      event: "sliderMove",
      sliderPosition: selectedLevel,
      sliderName: currentSliderName
    })
  }
});
});

  
// SMOOTH SCROLL
// Select all links with hashes
$('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
  // On-page links
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
    && 
    location.hostname == this.hostname
  ) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000, function() {
        // Callback after animation
        // Must change focus!
        var $target = $(target);
        $target.focus();
        if ($target.is(":focus")) { // Checking if the target was focused
          return false;
        } else {
          $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
          $target.focus(); // Set focus again
        };
      });
    }
  }
});